import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { distinctUntilChanged, Observable, Subscription, take } from 'rxjs';
import { StartOrderService } from '../../custom-start-order/start-order.service';
import { Router } from '@angular/router';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ContentService } from '../../spartacus/services/content.service';
import { ApiFailureDialogService } from '../../api-failure-dialog/api-failure-dialog.service';


@Component({
    selector: 'app-locationpage',
    templateUrl: './locationpage.component.html',
    styleUrl: './locationpage.component.scss',
    standalone: false
})
export class LocationpageComponent {
  displayedColumns: string[] = ['checkbox', 'locname', 'state', 'address', 'orderPlaced'];
  dataSource: any;
  selection = new SelectionModel<any>(true, []);
  seasonValue: string = '';
  shippingLocations: any;
  enablePage: any;
  isLoading: boolean = false;
  inseason: string = '';
  preseason: string = '';
  prepreseason:string='';
  landingapi: any;
  stockPopup: boolean = false;
  isAsmUser: boolean = false;
  popupdata: any;
  calendlyData: any;
  dontShowAgain = false;
  stockoutpopdata: any;
  unavailableProductName: string = '';
  private enablePageSub?: Subscription;
  private seasonSub?: Subscription;
  private productRequested = false;
  constructor(private dialogservice:ApiFailureDialogService,public component: CmsComponentData<CmsBannerComponent>, private cdr: ChangeDetectorRef, private router: Router, private startOrderService: StartOrderService, private userInfoService: UserInfoService,private contentservice: ContentService,private cmsService:CmsService,protected config: OccConfig) {

  }
  locationData: Observable<any> = this.component.data$;
  exitPopupData: any;
  ngOnInit() {
    this.contentservice.startapi().subscribe(data => {
      this.landingapi=data;
      this.inseason=this.landingapi?.currentInSeason;
      this.preseason=this.landingapi?.preSeason;
      this.prepreseason=this.landingapi?.prePreSeason
      this.cdr.detectChanges();
    });
    this.enablePageSub = this.userInfoService.getEnablePage().pipe(distinctUntilChanged()).subscribe((data: any) => {
      this.enablePage = data;
      if (this.enablePage?.showLocationPage) {
        this.productRequested = false; // allow "Select product" again when back on location page
      }
      if (this.enablePage.showLocationPage && !this.enablePage.isProductBackBtnClicked) {
        this.isLoading = true;
        this.scrollToTop();
        this.seasonSub?.unsubscribe();//cancel previous subscription to avoid memory leaks
        this.seasonSub = this.userInfoService.getstartorderseason().pipe(distinctUntilChanged()).subscribe((seasonValue: any) => {
          this.seasonValue = seasonValue;
          this.startOrderService.getUkShippingLocations(seasonValue).subscribe((data: any) => {
            this.checkUnavailableProductPopup(data);
            if(data?.errorCode=="500" && localStorage.getItem('FailureDailog') != 'true'){
              this.isLoading=false;
              this.dialogservice.openErrorDialog();
              localStorage.setItem('FailureDailog', 'true');
              this.cdr.detectChanges();
            }
            if(data && this.enablePage.showLocationPage && !this.enablePage.isProductBackBtnClicked) {
            this.shippingLocations = data.shippingData.filter((el: any) => {
              if (el.rbaPermission === 'manage') {
                return el;
              }
            })
            this.shippingLocations.forEach((el: any) => {
              el.checked = el.checked == "true" ? true : false;
              el['rowChecked'] = false;
              if (el.rowChecked) {
                this.selection.toggle(el);
              }
            })
            
            this.dataSource = new MatTableDataSource(this.shippingLocations);
            this.dataSource.filterPredicate = function (data: any, filter: string): boolean {
              return (data.locname && data.locname.toLowerCase().includes(filter)) || (data.address && data.address.toLowerCase().includes(filter)) || (data.state && data.state.toLowerCase().includes(filter));
            };
            this.isLoading = false;
            this.cdr.detectChanges();
          }
          }, (error) => {
            console.log('error: ', error);
            this.isLoading = false;
            this.startOrderService.setApiFailurePopup(true);
            this.cdr.detectChanges();
          })
        }, (error) => {
          console.log('error: ', error);
          this.isLoading = false;
          this.cdr.detectChanges();
        })
      }
    }, (error) => {
      console.log('error: ', error);
      this.isLoading = false;
      this.cdr.detectChanges();
    })
    // const data = [{
    //   "address": "1230 BAY DALE DR",
    //   "checked": "",
    //   "locID": "0060054154",
    //   "locname": "Rediclinic #48489",
    //   "rbaPermission": "manage",
    //   "state": "ARNOLD, MD  21012"
    // }, {
    //   "address": "8701 GEORGIA AVE STE 100",
    //   "checked": "",
    //   "locID": "0060054166",
    //   "locname": "Rediclinic #46761",
    //   "rbaPermission": "manage",
    //   "state": "SILVER SPRING, MD  20910"
    // }];
    this.isAsmUser = this.userInfoService.checkAsmUser();
    this.contentservice.getNavigation('calendlyPopUp').subscribe(res => {
      this.popupdata = res;
    });
  }

  ngOnDestroy() {
    this.enablePageSub?.unsubscribe();
    this.seasonSub?.unsubscribe();
  }

  handleOnRowClick(row: any) {
    if (row.checked) {
    return;
    }    
    row['rowChecked'] = !row['rowChecked'];
    this.selection.toggle(row);
    this.cdr.detectChanges();
  }
  inputclick(row: any){
    row['rowChecked'] = !row['rowChecked'];
    this.selection.toggle(row);
    this.cdr.detectChanges;
  }
  inputspanclick(row: any){
    row['rowChecked'] = !row['rowChecked'];
    this.selection.toggle(row);
    this.cdr.detectChanges;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  handleOnSelectAllBtnClick() {
    this.dataSource.data.forEach((row: any) => {
      if (row['rowChecked'] == false && row['checked'] == false) {
        row['rowChecked'] = true;
        this.selection.toggle(row);
      }
    })
  }
  handleOnClearSelection() {
    this.dataSource.data.forEach((row: any) => {
      row['rowChecked'] = false;
    })
    this.selection.clear();
  }
  handleOnOrderLinkClick() {
    this.userInfoService.setPopUpValue(true);
    this.userInfoService.setRouteLink("/orders/my-orders");
    this.userInfoService.setQueryParams({ season: this.seasonValue });
    /* this.router.navigate(
      ['/orders/my-orders'],
      { queryParams: { season: this.seasonValue } }
    ); */
  }
  handleOnExitClick() {
    this.userInfoService.setPopUpValue(true);
    this.userInfoService.setRouteLink("/my-account");
  }
  handleRequestDoseBtnClick() {
    if (this.productRequested) {
      return; // prevent duplicate getProductPageDetails calls on double-click
    }
    this.productRequested = true;
    const selectedLoc = this.selection.selected.map((el: any) => {
      return el.locID;
    })
    const locationPayload = {
      selectedLoc: [...selectedLoc],
      season: this.seasonValue
    }
    this.startOrderService.getUkProductDetails(locationPayload);
    const obj = {
      showLandingPage: false,
      showLocationPage: false,
      showProductPage: true,
      isProductBackBtnClicked: false,
      showReviewPage: false
    }
    this.userInfoService.setEnablePage(obj);
  }
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
//stock popup
  getMediaImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image?.url;
  }
checkUnavailableProductPopup(response: any): void {

  // Show popup only for in-season
  if (this.seasonValue !== this.inseason) {
    this.stockPopup = false;
    return;
  }

  // If productList is not available, don't show popup
  if (!response?.productList?.length) {
    this.stockPopup = false;
    return;
  }

  const unavailableProduct = response.productList.find(
    (product: any) => product.sellable === false
  );

  // No unavailable product found
  if (!unavailableProduct) {
    this.stockPopup = false;
    return;
  }
 const bothUnavailable = response.productList.every((product: any) => product.sellable === false);

 this.unavailableProductName = bothUnavailable? 'ALL': unavailableProduct.baseName;

  // Build CMS component dynamically
  const cmsComponent = bothUnavailable ? 'BothProductsUnavailablePopup' : `${unavailableProduct.baseName}-UnavailablePopup`;

  this.contentservice.getNavigation(cmsComponent).subscribe(res => {
    this.stockoutpopdata = res;
    this.stockPopup = true;
    this.cdr.detectChanges();
  });
}
  //for closing stock popup 
  closestockpopup(){
    if (this.dontShowAgain && this.unavailableProductName) {
      this.startOrderService.disableStockPopup(this.unavailableProductName).subscribe({
        error: (err) => console.error('disableStockPopup failed', err)
      });
    }
    this.stockPopup = false;
    this.cdr.detectChanges();
  }
  //for calendly popup
  ngAfterViewInit(){
    this.contentservice.vsscontent().subscribe(value => { 
      this.calendlyData = value;
     this.cdr.detectChanges();
    })
  }
  openCalendly() {
    if (this.calendlyData) {
       window.open(this.calendlyData.calendlyId, '_blank');
     }
  }
  openCalendlyModal() {
    if (this.dontShowAgain && this.unavailableProductName) {
      this.startOrderService.disableStockPopup(this.unavailableProductName).subscribe({
        error: (err) => console.error('disableStockPopup failed', err)
      });
    }
    document.body.style.overflowY = 'auto';
    this.stockPopup = false;
    document.getElementById('stockpop_Calendly_PopUp')!.style.display = 'block';
    this.cdr.detectChanges();
  }
  closeCalendlyModal() {
    document.body.style.overflowY = 'auto';
    document.getElementById('stockpop_Calendly_PopUp')!.style.display = 'none';
    // this.stockPopup = true;
  }
}
